"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentHistoryEntry = /** @class */ (function () {
    function PaymentHistoryEntry(isInput, delta, asset, assetId, other, timestamp, transactionId, blockHeight) {
        this.isInput = isInput;
        this.delta = delta;
        this.asset = asset;
        this.assetId = assetId;
        this.other = other;
        this.timestamp = timestamp;
        this.transactionId = transactionId;
        this.blockHeight = blockHeight;
    }
    PaymentHistoryEntry.prototype.adaptForSerialization = function () {
        var _a = this, isInput = _a.isInput, delta = _a.delta, asset = _a.asset, assetId = _a.assetId, other = _a.other, timestamp = _a.timestamp, transactionId = _a.transactionId, blockHeight = _a.blockHeight;
        return {
            isInput: isInput,
            delta: delta,
            asset: asset,
            assetId: assetId.toString('hex'),
            other: other,
            timestamp: timestamp.getTime(),
            transactionId: transactionId.toString('hex'),
            blockHeight: blockHeight
        };
    };
    return PaymentHistoryEntry;
}());
exports.default = PaymentHistoryEntry;
//# sourceMappingURL=payment-history-entry.js.map